import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ref, onValue, remove } from "firebase/database";
import { db } from "../firebaseConfig";
import webdevelopment from '../Assets/Bilal3.jpg'
// Styled components for the Products page
const MainContanier = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const ProductsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));  // Responsive grid layout
  gap: 20px;  // Space between the cards
  width: 100%;
  max-width: 1200px;  // Maximum width for large screens
  margin-top: 30px;  // Space between the title and products
`;

const Card = styled.div`
  border: none;
  border-radius: 15px;
  overflow: hidden;
  justify-content: center;
  width: 100%;
  max-width: 350px; /* Card ki ek upper limit define kare */
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow effect */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  /* Hover effect */
  &:hover {
    transform: scale(1.05); /* Thoda zoom on hover */
    box-shadow: 0px 12px 20px rgba(0, 0, 0, 0.2);
  }

  /* For images inside the card */
  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    object-fit: cover; /* Image ko properly adjust kare */
    margin-bottom: 15px; /* Spacing between image and other content */
  }

  /* Card content alignment */
  h3 {
    font-size: 1.5rem;
    color: #333;
    margin: 10px 0;
  }

  p {
    font-size: 1rem;
    color: #666;
    text-align: center;
    line-height: 1.5;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    padding: 15px;
    max-width: 90%; /* Mobile ke liye width adjust kare */
  }

  @media (max-width: 480px) {
    padding: 10px;
    max-width: 100%;
  }
`;


const CardImage = styled.img`
  width: 270px;
  height: 270px;
  object-fit: cover;
  border-radius: 10px;
`;

const CardTitle = styled.h3`
  margin: 10px 0;
  font-size: 20px;
  color: darkblue;
`;

const CardDescription = styled.p`
  font-size: 16px;
  color: #333;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center; /* Button ko horizontally center align kare */
  align-items: center; /* Button ko vertically center align kare */
  width: 100%; /* Full width le kar button ko center kare */
  margin-top: 15px; /* Button ke upar thoda spacing de */
`;

const BuyButton = styled.a`
  background-color: #28a745;
  color: white;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #218838;
  }
`;



const DeleteButton = styled.button`
  background-color: #dc3545;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #c82333;
  }
`;
const MobileAppImage = styled.img`
position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
  margin-bottom: 20px;
  @media (max-width:600px){
  width:100%;
  height:220px;
}
@media (min-width:601px) and (max-width:1024px){
  width:100%;
  height:320px;
}
`

const Products = () => {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    const cardsRef = ref(db, "cards");
    onValue(cardsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadedCards = Object.entries(data)
          .map(([key, value]) => ({
            id: key,
            ...value,
          }))
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sort by date
        setCards(loadedCards);
      }
    });
  }, []);

  const handleDelete = (cardId) => {
    const cardRef = ref(db, `cards/${cardId}`);
    remove(cardRef)
      .then(() => {
        setCards(cards.filter((card) => card.id !== cardId));
      })
      .catch((error) => {
        console.error("Error deleting card: ", error);
      });
  };

  return (
    <MainContanier>
      <MobileAppImage src={webdevelopment} alt='Background' />
      <h1>Our Products</h1>

      {/* Grid Container for the Products */}
      <ProductsContainer>
        {cards.map((card) => (
          <Card key={card.id}>
  <CardImage src={card.url} alt={card.title} />
  <CardTitle>{card.title}</CardTitle>

  {/* Description with Read More/Read Less functionality */}
  <CardDescription>
    {card.description.split(" ").length > 15 ? (
      <>
        {card.isExpanded
          ? card.description
          : card.description.split(" ").slice(0, 15).join(" ") + "..."}
        <button
          onClick={() => {
            setCards((prevCards) =>
              prevCards.map((c) =>
                c.id === card.id ? { ...c, isExpanded: !card.isExpanded } : c
              )
            );
          }}
          style={{
            background: "none",
            border: "none",
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
            marginLeft: "10px",
          }}
        >
          {card.isExpanded ? "Read Less" : "Read More"}
        </button>
      </>
    ) : (
      card.description
    )}
  </CardDescription>

  {/* Button Container */}
  <ButtonContainer>
    <BuyButton href={card.buyUrl} target="_blank">Buy Now</BuyButton>
    {/* <DeleteButton onClick={() => handleDelete(card.id)}>Delete</DeleteButton> */}
  </ButtonContainer>
</Card>
        ))}
      </ProductsContainer>
    </MainContanier>
  );
};

export default Products;
